/* src/app/shared/components/survey/survey-form/survey-form.component.css */
.survey-date-input {
  width: 100%;
  cursor: pointer;
}
.ant-radio-group {
  display: flex;
  justify-content: start;
  flex-direction: column;
}
.multi-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.multi-checkbox-group .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
.inline-subquestion {
  margin-top: 8px;
  padding-left: 24px;
  width: 100%;
}
.inline-subquestion-label {
  font-weight: 500;
  margin-bottom: 4px;
}
.inline-error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.survey-read-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.survey-read-item:last-child {
  border-bottom: none;
}
.survey-read-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.survey-read-value {
  color: #595959;
  font-size: 14px;
}
.survey-history-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}
.survey-history-date {
  font-weight: 600;
  color: #595959;
  font-size: 13px;
}
.survey-history-nav-btns {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
}
.survey-history-nav-btns button {
  border: 1px solid #d9d9d9;
  background: #fff;
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
}
.survey-history-nav-btns button:disabled {
  opacity: 0.4;
  cursor: default;
}
/*# sourceMappingURL=survey-form.component-ZLOVK6V2.css.map */
